// extracted by mini-css-extract-plugin
var _1 = "academicDebts-module_academicDebts_info__yjCIrA";
var _2 = "academicDebts-module_academicDebts_table__O4Upjb";
var _3 = "academicDebts-module_academicDebts_table_container__mzhzCp";
var _4 = "academicDebts-module_academicDebts_table_td__oORzh3";
var _5 = "academicDebts-module_academicDebts_table_th__wReXHs";
var _6 = "academicDebts-module_academicDebts_table_thead__FemEBF";
var _7 = "academicDebts-module_academicDebts_table_tr__CfNbeH";
var _8 = "academicDebts-module_academicDebts_thead_tr__S4Jr2Z";
export { _1 as "academicDebts_info", _2 as "academicDebts_table", _3 as "academicDebts_table_container", _4 as "academicDebts_table_td", _5 as "academicDebts_table_th", _6 as "academicDebts_table_thead", _7 as "academicDebts_table_tr", _8 as "academicDebts_thead_tr" }
